import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

import { ErrorMessageModel } from '../core/models/error-message.model';

@Injectable({
    providedIn: 'root'
})
export class ErrorMessagesService {
    shouldDisplayAlertOnError = true;
    onError = new Subject<ErrorMessageModel>();

    setError(error: ErrorMessageModel): void {
        this.onError.next(error);
    }
}
